
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiClassiAssetEsperienzeGrid extends Serenity.EntityGrid<ProdottiClassiAssetEsperienzeRow, any> {
        protected getColumnsKey() { return ProdottiClassiAssetEsperienzeColumns.columnsKey; }
        protected getDialogType() { return ProdottiClassiAssetEsperienzeDialog; }
        protected getIdProperty() { return ProdottiClassiAssetEsperienzeRow.idProperty; }
        protected getInsertPermission() { return ProdottiClassiAssetEsperienzeRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiClassiAssetEsperienzeRow.localTextPrefix; }
        protected getService() { return ProdottiClassiAssetEsperienzeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}